import { StatusModal } from '@/components/molecules';

interface StatusModalsProps {
  showSuccessModal: boolean;
  setShowSuccessModal: (show: boolean) => void;
  showFailureModal: boolean;
  setShowFailureModal: (show: boolean) => void;
  showSyncingModal?: boolean;
  setShowSyncingModal?: (show: boolean) => void;
  onSuccess: () => void;
}

export const StatusModals = ({
  showSuccessModal,
  setShowSuccessModal,
  showFailureModal,
  setShowFailureModal,
  showSyncingModal = false,
  setShowSyncingModal,
  onSuccess,
}: StatusModalsProps) => {
  return (
    <>
      {/* Success Modal */}
      <StatusModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        type="success"
        title="Congratulations"
        description="You've successfully connected your account"
        buttonText="Go Back Home"
        onButtonClick={() => {
          setShowSuccessModal(false);
          onSuccess();
        }}
      />

      <StatusModal
        isOpen={showSyncingModal}
        onClose={() => setShowSyncingModal?.(false)}
        type="success"
        title="WhatsApp is syncing"
        description="Contacts and up to 6 months of chat history can take a few minutes. Keep the WhatsApp Business App open on your phone while this runs. Conversations will appear here as they sync."
        buttonText="Got it"
        onButtonClick={() => setShowSyncingModal?.(false)}
      />

      {/* Failure Modal */}
      <StatusModal
        isOpen={showFailureModal}
        onClose={() => setShowFailureModal(false)}
        type="error"
        title="Account Failed"
        description="Your setup failed due to an unexpected error."
        buttonText="Go to home"
        onButtonClick={() => setShowFailureModal(false)}
      />
    </>
  );
};
